import { render, staticRenderFns } from "./newPeopleRead.vue?vue&type=template&id=92e089d8&"
import script from "./newPeopleRead.vue?vue&type=script&lang=js&"
export * from "./newPeopleRead.vue?vue&type=script&lang=js&"
import style0 from "./newPeopleRead.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports